import tw, { css } from 'twin.macro'

const storeRocketStyle = css`
  .storerocket-filter-button {
    ${tw`!hidden`}
  }

  #storerocket-widget {
    display: flex;
    flex-direction: column-reverse;
  }
  #storerocket-panel {
    padding-top: 0;
  }
`

export default storeRocketStyle
